import { create } from "zustand";

export type ThemeMode = "dark" | "light";

export interface AppState {
  theme: ThemeMode;
  sidebarCollapsed: boolean;
  /** Drawer del menú en móvil (abierto/cerrado). En escritorio no tiene efecto visual. */
  mobileNavOpen: boolean;
  /** Se incrementa al guardar la config de sincronización, para reprogramar el temporizador (item 6). */
  syncNonce: number;
  setTheme: (theme: ThemeMode) => void;
  toggleTheme: () => void;
  toggleSidebar: () => void;
  closeMobileNav: () => void;
  bumpSync: () => void;
}

/** Aplica el tema al documento (data-theme leído por tokens.css). */
export function applyTheme(theme: ThemeMode): void {
  if (typeof document !== "undefined") {
    document.documentElement.setAttribute("data-theme", theme);
  }
}

export const useAppStore = create<AppState>((set, get) => ({
  theme: "dark",
  sidebarCollapsed: false,
  mobileNavOpen: false,
  syncNonce: 0,
  setTheme: (theme) => {
    applyTheme(theme);
    set({ theme });
  },
  toggleTheme: () => {
    const next: ThemeMode = get().theme === "dark" ? "light" : "dark";
    applyTheme(next);
    set({ theme: next });
  },
  // En escritorio alterna el ancho del sidebar; en móvil abre/cierra el drawer (un solo botón sirve para ambos).
  toggleSidebar: () => set((s) => ({ sidebarCollapsed: !s.sidebarCollapsed, mobileNavOpen: !s.mobileNavOpen })),
  closeMobileNav: () => set({ mobileNavOpen: false }),
  bumpSync: () => set((s) => ({ syncNonce: s.syncNonce + 1 })),
}));
